import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../styles/colors';
import Icon from './Icon';
import { devices } from '../styles/breakpoints';

const successMixin = css`
  border: 1px solid ${colors.SUCCESS};
  color: ${colors.SUCCESS};
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;

  ${({ success }) => (success ? successMixin : '')}
`;

const MessageWrapper = styled.div`
  display: flex;
  flex: 1;
`;

const Message = styled.span`
  font-size: 16px;

  @media ${devices.desktop} {
    font-size: 20px;
  }
`;

const StyledIcon = styled(Icon)`
  font-size: 32px;
  margin-right: 8px;
`;

export default function Alert(props) {
  return (
    <Container {...props}>
      <StyledIcon name="check-selected" />
      <MessageWrapper>
        <Message>Sua alteração foi realizada com sucesso!</Message>
      </MessageWrapper>
    </Container>
  );
}
